module.exports = __webpack_public_path__ + "img/MG_2619.af7eb5f5.jpg";